<template>
  <el-form ref="formValidate"
           :model="userDetail"
           label-width="180px">
    <el-row>
      <el-col :span="12">
        <el-form-item :label="$t('user.account')"
                      prop="loginName">
          <el-input v-model="userDetail.loginName"
                    disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('user.userName')"
                      prop="name">
          <el-input v-model="userDetail.name"
                    disabled></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item :label="$t('user.department')"
                      prop="deptName">
          <el-input v-model="userDetail.deptName"
                    disabled>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('user.role')"
                      prop="roleName">
          <el-input v-model="userDetail.roleName"
                    disabled></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item :label="$t('user.email')"
                      prop="email">
          <el-input :value="emailFormat(userDetail.email)"
                    disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('user.phone')"
                      prop="phone">
          <el-input :value="phoneFormat(userDetail.phone)"
                    disabled></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item :label="$t('user.nickName')"
                      prop="nickName">
          <el-input v-model="userDetail.nickName"
                    disabled></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('user.sex')"
                      prop="sex">
          <zk-dictionary-select type="sex"
                                v-model="userDetail.sex"
                                disabled
                                clearable></zk-dictionary-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-form-item :label="$t('user.status')"
                      prop="status">
          <zk-dictionary-select type="status"
                                v-model="userDetail.status"
                                disabled></zk-dictionary-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="$t('user.registerTime')"
                      prop="createTime">
          <el-input :value="convertTime(userDetail.createTime)"
                    disabled></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import { dateFormat, dateByTimestamp } from '../../../utils/index.js'
export default {
  name: 'zk-user-detail',
  props: ['userDetail'],
  methods: {
    convertTime (timeStamp) {
      return dateFormat(dateByTimestamp(timeStamp))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/userDetail/src/main.vue